
import {Component, Prop, Vue} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import {QueryStage} from "@/components/query/QueryStates";
import IQueryShortDto = MdbsCore.IQueryShortDto;

@Component({
  name: 'DataFieldQueriesCountIcon',
  components: {},
})
export default class DataFieldQueriesCountIcon extends Vue {

  @Prop({required: true})
  private queries: Array<IQueryShortDto>;

  get iconColor() {
    const allClosed = this.queries.every(q => q.stageState == QueryStage.CLOSED);
    if (allClosed)
      return "success";

    const allAnswered = this.queries.every(q => q.lastComment?.creatingUserRoleIdentifier == "Physician" ||
        q.lastComment?.creatingUserRoleIdentifier == "Nurse");
    if (allAnswered)
      return "info"

    const hasActive = !allClosed;
    if (hasActive)
      return "error";

    return "primary";
  }

  get itemsNew() {
    this.queries.filter(query => !query.lastComment)
    return this.queries.filter(query => query.stageState == QueryStage.OPEN && !query.lastComment).length;
  }

  get itemsRenewed() {
    return this.queries.filter(query => query.stageState == QueryStage.OPEN &&
        (query.lastComment?.creatingUserRoleIdentifier == "DataManager" ||
            query.lastComment?.creatingUserRoleIdentifier == "SafetyManager")).length;
  }

  get itemsAnswered() {
    return this.queries.filter(query => query.stageState == QueryStage.OPEN &&
        (query.lastComment?.creatingUserRoleIdentifier == "Physician" ||
            query.lastComment?.creatingUserRoleIdentifier == "Nurse")).length;
  }

  get itemsPending() {
    return this.queries.filter(query => query.stageState == QueryStage.PENDING).length;
  }

  get itemsClosed() {
    return this.queries.filter(query => query.stageState == QueryStage.CLOSED).length;
  }
}
